import styled from "styled-components";


export const ContainerChat = styled.div`
position: fixed;
bottom:0;
width: 20%;
height: ${({show}) => show ? '60%' : '10%'};
background-color: transparent;
z-index:4;
right: 0;
display: flex;
align-items: end;
flex-direction: column-reverse; 
align-items: flex-start;
  @media screen and (max-width: 600px) {
    width: 70%;
    bottom:0%;
  }

  @media screen and (min-width: 767px) and (max-width: 769px) {
    width: 50%;
}

  @media screen and (min-width: 819px) and (max-width: 821px) {
    width: 50%;
}
  @media screen and (min-width: 1023px) and (max-width: 1025px) {
    width: 50%;
}

  @media screen and (min-width: 911px) and (max-width: 913px) {
    width: 50%;
}

  @media screen and (min-width: 852px) and (max-width: 854px) {
    width: 50%;
}


  @media screen and (min-width: 624px) and (max-width: 626px) {
    width: 50%;
}
   
         

`
export const MessageContainer = styled.div`
width: 100%;
background:  rgba(10, 10, 10, 1);
overflow: hidden; 
height: ${props => (props.open ? "100%" : "0")};
transition: height 0.5s ease; 
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
position: relative;
//border: solid 1px black;
border-radius: 3px 3px 0 0;







`

export const MessageHeader = styled.div`
width: 100%;
height: 10%;
color: white;
cursor: pointer;

background-color: rgba(61, 46, 226, 0.9);
background-color: rgba(61, 46, 226, 0.6); /* Fondo semi-transparente */
backdrop-filter: blur(8px); /* Ajusta el nivel de blur */
-webkit-backdrop-filter: blur(8px); /* Soporte Safari */
display: ${props => props.show  ? 'flex' : 'none'};
align-items: center;

margin-bottom: 1px;
padding-top: 15px;
padding-bottom: 15px;
    @media screen and (max-width: 600px) {
   
    
    
    
  }
    
`

export const MessageIconContainer = styled.div`
  padding-left:10px ;
  width: 100%;
   
  box-sizing: border-box;

  display: flex;
  align-items: center;


 
  
`

export const BodyMessage = styled.div`
 width: 100%;
 height: 100%;
 background-color: aliceblue ;
 padding: 5px !important;
 display: flex;
 justify-content: center;
 align-items: center;
 flex-direction: column;
 

`

export const TextAreaContainer = styled.div`
width: 100%;
height: 30%;
padding: 5px;
background-color: aliceblue;


`

export const TextArea = styled.textarea`
width: 100%;
margin: auto;
resize: none;
outline: none;
padding: 4px 3px 4px 3px;
height: 90px;
border: none;
background-color: #dfe6f6ff;
border-radius: 3px 3px 8px 8px;
border: solid 1px #c9bdbdff;
border-bottom: solid 3px #c9bdbdff;

`

export const ButtonSendContainer = styled.div`

padding: 5px;
box-sizing: border-box;

width: 100%;
background-color: #f5f7f5ff;
display: ${props => props.show ? 'flex' : 'none'};
justify-content:flex-end;






`

export const ButtonIcon = styled.button`
margin-right: 20px;
background-color: rgba(24, 27, 24, 1);
border-radius: 3px;
font-size: 10px;
color: #e6ebe6ff; 
cursor: pointer;
padding: 4px;
   &:active {
    background-color: rgba(24, 27, 24, .5);; 
    color: #181b18ff;
  }

    @media screen and (max-width: 600px) {
        margin: auto;
    }
`

export const Message1 = styled.div`
width: 99%;
height: 25vh;
background-color: #dee1e8ff;

border: solid 1px #c9bdbdff;

border-radius: 3px;
 overflow-y: auto;
 padding: 10px;
 
 //Iphone SE
 @media screen and (min-width:  374px) and (max-width: 376px) {
    height: 160px;
}
// Iphone xr
@media screen and (min-width: 413px) and (max-width: 415px) {
    height: 260px;
}
// iphone 12 pro
@media screen and (min-width: 389px) and (max-width: 391px) {
    height: 220px;
}
// iphone 14
@media screen and (min-width: 429px) and (max-width: 431px) {
    height: 260px;
}
// pixel  
@media screen and (min-width: 411px) and (max-width: 413px) {
    height: 260px;
}

// samsung galaxi 8

@media screen and (min-width: 359px) and (max-width: 361px) {
    height: 190px;
}

// samsung ultra 20 

// ipad mini
@media screen and (min-width: 767px) and (max-width: 769px) {
    height: 310px;
}
// ipad air
@media screen and (min-width: 819px) and (max-width: 821px) {
    height: 370px;
}
// ipad pro
@media screen and (min-width: 1023px) and (max-width: 1025px) {
    height: 430px;
}

// pro 7
@media screen and (min-width: 911px) and (max-width: 913px) {
    height: 450px;
}

// z fold 
@media screen and (min-width: 342px) and (max-width: 344px) {
    height: 260px;
}

@media screen and (min-width: 852px) and (max-width: 854px) {
    height: 400px;
}

@media screen and (min-width: 1279px) and (max-width: 1281px) {
    height: 190px;
}

@media screen and (min-width: 539px) and (max-width: 541px) {
    height: 170px;
}
`
export const Chatlabel = styled.div`
 margin-left: 3px;
 margin-right: 10px;
  @media screen and (max-width: 600px) {
    
    //display: none;
  }
    

`



export const MessageRow1 = styled.div`
  display: flex;
  justify-content: ${({ isMine }) => (isMine ? "flex-end" : "flex-start")};
  margin-bottom: 1rem;
`;

export const MessageBubble1 = styled.div`
  max-width: 70%;
  padding: 0.5rem 0.75rem;
  border-radius: 8px;
  background: ${({ isMine }) => (isMine ? "#3167beff" : "#ffffffff")};
  color: ${({ isMine }) => (isMine ? "#d9dee6ff" : "#0e1217ff")};
   overflow-wrap: break-word;
  word-wrap: break-word; 
   user-select: text; 
`;

export const Author1 = styled.small`
  display: block;
  color: ${({ isMine }) => (isMine ? "#dbeafe" : "#6c757d")};
  margin-bottom: 0.25rem;
`;

export const Time1 = styled.small`
  display: block;
  text-align: right;
  color: ${props => props.colore ? '' : '#6c757d '};
  margin-top: 0.25rem;
`;

export const Footer1 = styled.div`
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
`;

export const InputGroup1 = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const Input1 = styled.input`
  flex: 1;
  padding: 0.5rem 0.75rem;
  border-radius: 4px;
  border: 1px solid #ced4da;
  outline: none;

  &:focus {
    border-color: #0d6efd;
  }
`;

export const SendButton1 = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 4px;
  border: none;
  background: #0d6efd;
  color: white;
  cursor: pointer;

  &:hover {
    background: #0b5ed7;
  }
`;


